import { getSmtpSetting, updateSmtpSetting } from "api/siteSettings/smtp";
import { useMutation, useQuery } from "@tanstack/react-query";
import { printError, useSearch, useUtilities } from "helpers";
import { useEffect } from "react";
import { setSmtpSetting, updateSmtp } from "redux/reducers/siteSettings/smtp";
import { ApiResponseType, NotificationType } from "enums";
import { t } from "i18next";

export function useGetSmtpSetting() {
  const { web = null } = useSearch();
  return useQuery(["smtp", web], () => getSmtpSetting(web));
}

export function useSmtp() {
  const { web = null } = useSearch();
  const { data, isLoading, error } = useGetSmtpSetting();
  const {
    dispatch,
    smtp: { smtp, loaded, website_id },
  } = useUtilities();

  useEffect(() => {
    if (data && (!loaded || website_id !== web)) {
      dispatch(
        setSmtpSetting({
          smtp: data.data,
          website_id: web,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, error, loaded, web, website_id]);

  return {
    data: smtp,
    isLoading: isLoading || !loaded,
    error,
  };
}

export function useUpdateSmtpSetting() {
  const { notification, dispatch } = useUtilities();
  return useMutation(updateSmtpSetting, {
    onSuccess: (data) => {
      if (data.status_code === ApiResponseType.SUCCESS) {
        dispatch(updateSmtp(data.data));
        notification({
          type: NotificationType.SUCCESS,
          message: t("siteSetting.smtp.api.notification.updated"),
        });
      } else {
        notification({
          type: NotificationType.ERROR,
          message: printError(data.message),
        });
      }
    },
    onError: (err) => {
      notification({
        type: NotificationType.ERROR,
        message: printError(err.message),
      });
    },
  });
}
